import { Database } from '../firebaseInit.js';
import { action, computed, reaction, asMap, observable, toJS } from 'mobx';

class Course {
  @observable lecturesCompleted = 0;
  @observable lecturesCount = 0;
  @observable index = 1;

  saveHandler = null

  constructor(id, userId, payload) {
    this.id = id;
    this.userId = userId;
    this.saveHandler = reaction(
      () => this.asJson,
      (payload) => {
        Database.child('enrollments').child(this.userId).child('courses').child(this.id).set(payload);
      }
    );
    Database.child('enrollments').child(this.userId).child('courses').child(this.id).set(payload);
    this.set(payload);
  }

  @action set(payload) {
    Object.assign(this, payload);
  }

  @computed get completed() {
    return this.lecturesCompleted === this.lecturesCount;
  }

  @computed get percentage() {
    return `${Math.floor(this.lecturesCompleted/this.lecturesCount*100)}%`;
  }

  @computed get asJson() {
    return {
      lecturesCompleted: this.lecturesCompleted,
      lecturesCount: this.lecturesCount,
      index: this.index
    };
  }
}

class Lecture {
  @observable completed = false;
  @observable elapsed = 0;

  saveHandler = null

  constructor(id, userId, payload) {
    this.id = id;
    this.userId = userId;
    this.saveHandler = reaction(
      // observe everything that is used in the JSON:
      () => this.asJson,
      // if autoSave is on, send json to server
      (payload) => {
        Database.child('enrollments').child(this.userId).child('lectures').child(this.id).set(payload);
      }
    );
    Object.assign(this, payload);
  }

  @computed get asJson() {
    return {
      completed: this.completed,
      elapsed: this.elapsed
    };
  }
}

class EnrollmentStore {
  @observable courses = asMap();
  @observable lectures = asMap();

  @action subscribe = (userId) => {
    this.userId = userId;
    Database.child('enrollments').child(userId).child('lectures').on('value', (snap) => {
      const lectures = snap.val();
      if(lectures) {
        snap.forEach( (lecture) => {
          this.updateLecture(lecture.key, lecture.val());
        });
      }
    });
    Database.child('enrollments').child(userId).child('courses').on('value', (snap) => {
      const courses = snap.val();
      if(courses) {
        snap.forEach( (course) => {
          this.updateCourse(course.key, course.val());
        });
      }
    });
  }

  @action updateLecture = (id, payload) => {
    const lecture = this.lectures.get(id);
    (lecture) ? Object.assign(lecture, payload) : this.lectures.set(id, new Lecture(id, this.userId, payload));
  }

  @action updateCourse = (id, payload) => {
    const course = this.courses.get(id);
    (course) ? Object.assign(course, payload) : this.courses.set(id, new Course(id, this.userId, payload));
  }


  @action completeLecture = (lecture, lectureId, course) => {
    const lectureEnrollment = this.lectures.get(lectureId);
    if(lectureEnrollment) {
      const courseEnrollment = this.courses.get(lecture.courseId);
      const index = (lecture.index === course.lecturesCount) ? 1 : lecture.index + 1 ;
      (courseEnrollment && lectureEnrollment.completed === false) ? courseEnrollment.set({
        index: index,
        lecturesCompleted: ++courseEnrollment.lecturesCompleted
      })
      : this.courses.set(lecture.courseId,
        new Course(lecture.courseId, this.userId,
          {
            index: index,
            lecturesCompleted: 1,
            lecturesCount: course.lecturesCount
          }
        )
      );
      lectureEnrollment.elapsed = 0;
      lectureEnrollment.completed = true;
    }
  }
}

export default EnrollmentStore;


/** WEBPACK FOOTER **
 ** ./src/js/state/enrollment.js
 **/